function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { BottomSheet, BottomSheetBackdrop, BottomSheetSheet } from "sprout-ui-dom/dist/BottomSheet";
import { Popover } from "sprout-ui-dom/dist/Popover";
import applyMaxHeight from "sprout-ui-dom/dist/utils/applyMaxHeight";
import maxHeight from "sprout-ui-dom/dist/utils/maxHeight";
import { Box } from "sprout-ui-primitives";
import { MenuMenu } from "./MenuMenu";
const modifiers = [
    maxHeight,
    applyMaxHeight
];
const Menu = (props)=>{
    const { children , onOpenChange , open , referenceElement , className , triggerElement , placement , /* eslint-disable @typescript-eslint/no-unused-vars */ onOpenToggle , setReferenceElement , setTriggerElement  } = props, rest = _objectWithoutProperties(props, [
        "children",
        "onOpenChange",
        "open",
        "referenceElement",
        "className",
        "triggerElement",
        "placement",
        "onOpenToggle",
        "setReferenceElement",
        "setTriggerElement"
    ]);
    const handleClose = useCallback(()=>{
        onOpenChange(false);
    }, [
        onOpenChange
    ]);
    const handlePropagateClick = useCallback((event)=>{
        var ref;
        const target = event.target;
        const { tagName  } = target;
        const parentTagName = (ref = target.parentElement) === null || ref === void 0 ? void 0 : ref.tagName;
        const matches = [
            "A",
            "BUTTON"
        ];
        if (matches.includes(tagName) || parentTagName && matches.includes(parentTagName)) handleClose();
    }, [
        handleClose
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Popover, {
                open: open === "popover",
                referenceElement: referenceElement,
                triggerElement: triggerElement,
                onOpenChange: onOpenChange,
                placement: placement,
                modifiers: modifiers,
                children: /*#__PURE__*/ _jsx(MenuMenu, _objectSpread({
                    className: className
                }, rest, {
                    onClick: handlePropagateClick,
                    pb: null,
                    children: /*#__PURE__*/ _jsx(Box, {
                        overflowY: "auto",
                        pb: 3,
                        children: children
                    })
                }))
            }),
            /*#__PURE__*/ _jsxs(BottomSheet, {
                open: open === "bottom-sheet",
                unmountOnExit: true,
                children: [
                    /*#__PURE__*/ _jsx(BottomSheetBackdrop, {
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ _jsx(BottomSheetSheet, {
                        className: className,
                        bg: "blue.500",
                        py: 5,
                        onClick: handlePropagateClick,
                        children: children
                    })
                ]
            })
        ]
    });
};
export default Menu;
